// removed by extract-text-webpack-plugin
module.exports = {"nav":"src-components-Navigation----navigation-module---nav---4KTQR","right":"src-components-Navigation----navigation-module---right---_CcLq","top":"src-components-Navigation----navigation-module---top---ldXqQ","left":"src-components-Navigation----navigation-module---left---1qgEK","bottom":"src-components-Navigation----navigation-module---bottom---3_lnp","back":"src-components-Navigation----navigation-module---back---aACqV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/navigation.module.scss
// module id = 306
// module chunks = 168707334958949